// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadAmo_container__2E06M","title":"DownloadAmo_title__3-MA6","googleButton":"DownloadAmo_googleButton__PMpoz","bottom":"DownloadAmo_bottom__29GPO"};